import * as Html from "../../util/Html.ts";

export {init,destroy}

function init(node){
  node.css('height','0')
  node.css('overflow','hidden')
  node.css('transition','height 300ms linear');
  
  var 
    domNode = node.get(0),
    lastHeight = null,
    interval = setInterval(()=>{
      var 
        lastChild = domNode.lastChild,
        height = lastChild.offsetTop - domNode.offsetTop + lastChild.scrollHeight;
      if(height!==lastHeight){
        node.css('height',height+'px');
        lastHeight = height;
      }
    },100)
  node.attr("interval",interval)
}
function destroy(node){
  clearInterval(node.attr("interval"))
}
Html.registerWidget('widget/animation/SoftHeight',{init:init,destroy:destroy})